'use client';

import { useEffect, useRef } from 'react';
import { useLightboxActions, useLightboxState } from './LightboxContext';
import Image from 'next/image';
import { usePaginator } from '@commons/Paginator/PaginatorContext';
import Paginator from '@commons/Paginator/Paginator';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function LightboxViewer() {
  const { isOpen, currentImage } = useLightboxState();
  const { dictionary } = useDictionary();
  const { closeLightbox, updateCurrentImage } = useLightboxActions();
  const { index, items } = usePaginator();
  const dialogRef = useRef(null);

  const paginatorDots = [];
  for (let i = 0; i < 4; i++) {
    paginatorDots.push({
      index: i
    });
  }

  // dialog click is needed when backdrop is used, even though closedby="any" is set
  const handleDialogClick = (event) => {
    if (event.target === dialogRef.current) {
      closeLightbox();
    }
  };

  useEffect(() => {
    if (dialogRef.current) {
      if (isOpen) {
        dialogRef.current.showModal();
      } else {
        dialogRef.current.close();
        updateCurrentImage(null);
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (items && items.length > 0) {
      updateCurrentImage(items[index]);
    }
  }, [index, items]);

  useEffect(() => {
    dialogRef.current?.addEventListener('close', (e) => {
      closeLightbox();
    });

    return () => {
      dialogRef.current?.removeEventListener('close', () => {
        closeLightbox();
      });
    };
  }, []);

  return (
    <dialog ref={dialogRef} className="Lightbox__viewer" closedby="any" onClick={handleDialogClick}>
      {currentImage && (
        <Image
          src={currentImage.url}
          alt={currentImage.alt || dictionary?.image?.heroAlt || 'Hero image'}
          width={currentImage.width || 100}
          height={currentImage.height || 100}
          sizes="75vw"
        />
      )}

      <Paginator variant="dots" className="Lightbox__navigation">
        <Paginator.ItemBack />
        {paginatorDots.map((image, index) => (
          <Paginator.ItemDots key={index} activeIndex={index} item={image} className={`Hero__PaginatorItem`} />
        ))}
        <Paginator.ItemForward />
      </Paginator>
    </dialog>
  );
}
